import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import { Collapse } from "@mui/material"; // Add to top imports


import { Button, CircularProgress, Container, Divider, Typography, Snackbar, Alert,MenuItem,
    Select,
    FormControl,
    TextField,
    InputLabel} from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import axios from "axios";

// React Functional Component
const TryFreePage: React.FC = () => {
    const [file, setFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [openError, setOpenError] = useState(false);
    const [language, setLanguage] = useState("en"); // Default to English
    const [email, setEmail] = useState<string>('');
    const [confirmEmail, setConfirmEmail] = useState<string>('');
    const [showConfirmEmail, setShowConfirmEmail] = useState(false);


    const [openModal, setOpenModal] = useState(false);



    const MAX_FILE_SIZE_MB: number = 16
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * (1024*1024)
    const navigate = useNavigate();

    // useDropzone hook from react-dropzone
    const { getRootProps, getInputProps } = useDropzone({
        accept:{
            'audio':[".wav,.mp3"]
        },
        maxFiles:1,
        onDrop: (acceptedFiles) => {
        setErrorMessage(null); // Clear previous errors
        if (acceptedFiles.length > 0) {
            const selectedFile = acceptedFiles[0];
            if (selectedFile.size > MAX_FILE_SIZE) {
                setErrorMessage(`File size exceeds the ${MAX_FILE_SIZE_MB} MB limit.`);
                setOpenError(true);
                setFile(null);
            } else {
                setFile(selectedFile);
            }
        }
    },
});

    const callApi = async (formData: any) => {
        try {
            const response = await axios.post("/api/transcribe", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            });
            const data = response.data


        } catch (error) {
            console.error("Error uploading file:", error);
            setErrorMessage("An error occurred while uploading the file.");
            setOpenError(true);
        } finally {
            setLoading(false);
        }
    };
    const handleFileUpload = async () => {
        if (!file) {
            setErrorMessage("Please select a file before uploading.");
            setOpenError(true);
            return;
        }

        const emailError = validateEmail(email);
        if (emailError) {
            setErrorMessage(emailError);
            setOpenError(true);
            return;
        }

        if (email !== confirmEmail) {
            setErrorMessage("Email and Confirm Email do not match");
            setOpenError(true);
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append("audio", file);
        formData.append("language", language);
        formData.append('email',email)

        await callApi(formData);
        // Clear form
        setEmail("");
        setConfirmEmail("");
        setFile(null);
        setShowConfirmEmail(false);

    };
    const validateEmail = (email: string): string | null => {
        if (!email) return "Email is required";
        const basicRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!basicRegex.test(email)) return "Email format is invalid";

        return null;
    };
    return (
        <Container className="text-center" maxWidth="sm" id="free-trial-section">
            <Typography  sx={{ mt: 4 }}  variant="h3" gutterBottom>
                See it in Action!
            </Typography>
            <Typography variant="body1" >
                Upload a 1-minute voice note and watch our AI turn it into text instantly.
            </Typography>

            {/* Divider */}
            <Divider sx={{ marginBottom: 3 }} />

            {/* Language Selection Dropdown */}
            <FormControl fullWidth  sx={{
                marginBottom: 2,
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: '#e53935',
                    },
                    '&:hover fieldset': {
                        borderColor: '#e53935',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#e53935',
                    },
                },
            }}>
                <InputLabel id="lang-label" style={{color:'#e53935'}}>Select Language</InputLabel>
                <Select
                    labelId="lang-label"
                    value={language}
                    label="Select Language"
                    onChange={(e) => setLanguage(e.target.value)}
                >
                    <MenuItem value="en">English</MenuItem>
                    <MenuItem value="ar">Arabic</MenuItem>
                </Select>
            </FormControl>
            {/*email*/}
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <TextField
                    label="Email"
                    type="email"
                    variant="outlined"
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        setShowConfirmEmail(false);
                    }}
                    onBlur={() => {
                        const isValid = validateEmail(email) === null;
                        setShowConfirmEmail(isValid);
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: '#e53935' },
                            '&:hover fieldset': { borderColor: '#e53935' },
                            '&.Mui-focused fieldset': { borderColor: '#e53935' },
                        },
                        '& .MuiInputLabel-root': { color: '#e53935' },
                    }}
                />
            </FormControl>

            {/*Conform your email*/}
            <Collapse in={showConfirmEmail} timeout={400}>
                <FormControl fullWidth sx={{ marginBottom: 2 }}>
                    <TextField
                        label="Confirm Email"
                        type="email"
                        variant="outlined"
                        value={confirmEmail}
                        onChange={(e) => setConfirmEmail(e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#e53935' },
                                '&:hover fieldset': { borderColor: '#e53935' },
                                '&.Mui-focused fieldset': { borderColor: '#e53935' },
                            },
                            '& .MuiInputLabel-root': { color: '#e53935' },
                        }}
                    />
                </FormControl>
            </Collapse>


            {/* Dropzone (for file upload) */}
            <div {...getRootProps({ className: "dropzone" })} style={dropzoneStyles}>
                <input {...getInputProps()} />
                <p style={{ margin: 0 }}>Click to upload or drag & drop a file</p>
                <Typography variant="caption" color="textSecondary">
                    Max file size: 16 MB (.mp3, .wav)
                </Typography>
                {file && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        Selected file: <strong>{file.name}</strong>
                    </Typography>
                )}
            </div>

            {/* Loader and Button */}
            {loading ? (
                <CircularProgress />
            ) : (
                <Button
                    variant="contained"
                    onClick={handleFileUpload}
                    className="mt-3 px-4"
                    style={{backgroundColor:"#e53935"}}
                >
                    Upload Audio
                </Button>
            )}

            {/* Error Snackbar */}
            <Snackbar
                open={openError}
                autoHideDuration={6000}
                onClose={() => setOpenError(false)}
            >
                <Alert onClose={() => setOpenError(false)} severity="error" sx={{ width: "100%" }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ textAlign: 'center', pb: 0 }}>
                    <CheckCircle sx={{ fontSize: 60, color: '#4caf50' }} />
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center', px: 4, pb: 2 }}>
                    <Typography variant="h5" gutterBottom>
                        Upload Successful
                    </Typography>
                    <Typography variant="body1">
                        Your audio file has been uploaded successfully. The transcription will be sent to your email shortly.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                    <Button
                        onClick={() => setOpenModal(false)}
                        variant="contained"
                        sx={{ backgroundColor: '#e53935', '&:hover': { backgroundColor: '#d32f2f' } }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

const dropzoneStyles: React.CSSProperties = {
    border: "2px dashed #007bff",
    padding: "20px",
    cursor: "pointer",
    borderRadius: "8px",
    borderColor:"#e53935",
    marginBottom: "20px",
    textAlign: "center",
};

export default TryFreePage;
